// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 28/08/2023

import { ChangeDetectorRef, Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, ApiResponseModel, CtCustomSelect, CtFormComponent, CtInputCheckBoxComponent, CtInputNumberComponent, CtInputTextComponent, CtMessageComponent, CtTableComponent, HttpService, InputBaseComponent } from 'components';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { defaultIfEmpty, switchMap, take } from 'rxjs/operators';

@Component({
	selector: 'pa-vi06',
	template: `<div [id]="getId()" #target><div>`
})

export class PaVi06 extends BaseController{
	[x: string]: any;

	public docIdenAso: string;
	public numPat: number;
	public buttons : any[] = [];
	public mainAction : Action;
	private ctMessage : CtMessageComponent;
	private successMessage : "Se guardaron los cambios";
	private errorMessage : "No se pudieron guardar los cambios";

	constructor(private router : Router, private cdr : ChangeDetectorRef) {
		super();
		this.setViewCode('PA_VI06');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	public setAsociadoFromStore(action : Action): void {
		const input : CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		const inputPat : CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]);
		
		this.getAsociadoDocIdFromStoreService(input);
		this.getNumPatronoFromStoreService(inputPat);
		
	}

	private getAsociadoDocIdFromStoreService(input : CtInputTextComponent) {
		this.storeService.getStateObservable('docIdentificacionAso').pipe(
			take(1),
			defaultIfEmpty('')
		)
		.subscribe({
			next : (value) => {
				if(value === null || value === undefined || value === '') this.navigateToPA_VI05();
				this.docIdenAso = value;
				input.setValue(this.docIdenAso);
			}
		})
	}

	private getNumPatronoFromStoreService(inputPat : CtInputNumberComponent) {
		this.storeService.getStateObservable('numPatrono').pipe(
			take(1),
			defaultIfEmpty(0)
		)
		.subscribe({
			next : (value) => {
				if(value === null || value === undefined) this.navigateToPA_VI05();
				this.numPat = value;
				inputPat.setValue(this.numPat);
			}
		})
	}
	
	public setSummaryInfo(action: Action) {
		let numClienteInput = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
		let docIdInput = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
		let inputIdAsociado : CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[3])
		this.executeAsociadoInfoRequest(action, numClienteInput, docIdInput, inputIdAsociado);
	}

	private executeAsociadoInfoRequest(action: Action, numClienteInput: CtInputNumberComponent, docIdInput: CtInputTextComponent, inputIdAsociado: CtInputTextComponent) {
		this.getAsociadoInfo(numClienteInput, docIdInput).subscribe({
		  next: (response: ApiResponseModel) => {
			let data = response['Data']
			this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);
			let idAsociado = this.utilService.getStringAttribute('ID_ASOCIADO', data[0].ArrayEntities.List)
			inputIdAsociado.setValue(idAsociado);
		  },
		  error: (err: any) => {
			this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
			  true, 'Aceptar', 'Cancelar');
		  }
		});
	}
	
	private setSummaryAsociadoMetadata(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent): any {
		return {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [
			  {
				"Name": "NUM_PATRONO",
				"Alias": "NUM_PATRONO",
				"Value": numClienteInput
	
			  },
			  {
				"Name": "DOC_IDENTIFICACION",
				"Alias": "DOC_IDENTIFICACION",
				"Value": docIdInput
			  }
	
			]
		  },
		  "Data": []
		}
	}

	public getAsociadoInfo(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent): Observable<any> {
		const requestData: any = this.setSummaryAsociadoMetadata(numClienteInput, docIdInput);
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/ASOCIADO_PATRONO_PM/SER_RET_INFO_ASOCIADO_PM', requestData);
	}
	
	public setTableCuotas(action: Action) {
		let { numClienteInput, docIdInput, tipPlanillaMutInput, tipPlanillaCreInput, fecInicioInput, fecFinalInput }:
		 { numClienteInput: CtInputNumberComponent; docIdInput: CtInputTextComponent; tipPlanillaMutInput: CtInputCheckBoxComponent; 
			tipPlanillaCreInput: CtInputCheckBoxComponent; fecInicioInput: CtCustomSelect; fecFinalInput: CtCustomSelect; } 
			= this.getComponentRefsToSetCuotasInfo(action);
	
		this.executeCuotasInfoRequest(numClienteInput, docIdInput, tipPlanillaMutInput, tipPlanillaCreInput, fecInicioInput, fecFinalInput, action);
	}
	
	private executeCuotasInfoRequest(numClienteInput: CtInputNumberComponent, docIdInput: CtInputTextComponent, tipPlanillaMutInput: CtInputCheckBoxComponent, tipPlanillaCreInput: CtInputCheckBoxComponent, fecInicioInput: CtCustomSelect, fecFinalInput: CtCustomSelect, action: Action) {
		this.getAsociadosPatron(numClienteInput, docIdInput, tipPlanillaMutInput, tipPlanillaCreInput, fecInicioInput, fecFinalInput).subscribe({
			next: (response: ApiResponseModel) => {
				this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);
			},
			error: (err: any) => {
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
					true, 'Aceptar', 'Cancelar');
			}
		});
	}

	private getComponentRefsToSetCuotasInfo(action: Action) {
		let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
		let docIdInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
		let tipPlanillaCreInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[3]).getValue();
		let tipPlanillaMutInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[4]).getValue();
		let fecInicioInput: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[5]).getValue();
		let fecFinalInput: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[6]).getValue();
		return { numClienteInput, docIdInput, tipPlanillaMutInput, tipPlanillaCreInput, fecInicioInput, fecFinalInput };
	}

	private setTableAsociadosMetadata(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent,  
		tipPlanillaMutInput: CtInputCheckBoxComponent, tipPlanillaCreInput: CtInputCheckBoxComponent, fecInicioInput: CtCustomSelect,
		 fecFinalInput: CtCustomSelect): any {
		return {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [
			  {
				"Name": "NUM_PATRONO",
				"Alias": "NUM_PATRONO",
				"Value": numClienteInput
	
			  },
			  {
				"Name": "DOC_IDENTIFICACION",
				"Alias": "DOC_IDENTIFICACION",
				"Value": docIdInput
			  },
			  {
				"Name": "TIP_PLANILLA_CRE",
				"Alias": "TIP_PLANILLA_CRE",
				"Value": tipPlanillaCreInput
			  },
			  {
				"Name": "TIP_PLANILLA_MUT",
				"Alias": "TIP_PLANILLA_MUT",
				"Value": tipPlanillaMutInput
			  },
			  {
				"Name": "FEC_INICIO",
				"Alias": "FEC_INICIO",
				"Value": fecInicioInput
			  },
			  {
				"Name": "FEC_FINAL",
				"Alias": "FEC_FINAL",
				"Value": fecFinalInput
			  }
	
			]
		  },
		  "Data": []
		}
	}

	public getAsociadosPatron(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent,  tipPlanillaMutInput: CtInputCheckBoxComponent, tipPlanillaCreInput: CtInputCheckBoxComponent, fecInicioInput: CtCustomSelect, fecFinalInput: CtCustomSelect): Observable<any> {
		const requestData: any = this.setTableAsociadosMetadata( numClienteInput, docIdInput, tipPlanillaCreInput, tipPlanillaMutInput,fecInicioInput, fecFinalInput);
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/ASOCIADO_PATRONO_PM/SER_RET_CUOTAS_ASOCIADO_PM', requestData);
	}

	public editAsociado(action: Action) {
		let { form, docIdInput, numClienteInput }: 
		{ form: CtFormComponent; docIdInput: CtInputTextComponent; numClienteInput: CtInputNumberComponent; } 
			= this.getComponentRefsForEditAsociado(action);

		this.executeEditAsociadoRequest(form, docIdInput, numClienteInput);
	}

	private executeEditAsociadoRequest(form: CtFormComponent, docIdInput: CtInputTextComponent, numClienteInput: CtInputNumberComponent) {
		this.sendEditRequest(form, docIdInput, numClienteInput).subscribe({
			next: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.successMessage, "success")]);
			},
			error: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.errorMessage, "error")]);
			}
		});
	}

	private getComponentRefsForEditAsociado(action: Action) {
		let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		let docIdInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
		let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
		return { form, docIdInput, numClienteInput };
	}

	public sendEditRequest(form: CtFormComponent, docIdInput : CtInputTextComponent, numCliente : CtInputNumberComponent): Observable<any> {
		const requestData: any =  this.setADNUpdate(docIdInput,numCliente,form);
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/ASOCIADO_PATRONO_PM/UPD_ASOCIADO_PATRONO_PM/UpdateWithOperationAndEntity', requestData);
	}

	public deleteAsociado(action: Action) {
		let docIdInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
		let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
		this.setADNDelete(docIdInput,numClienteInput);
	}

	public setADNUpdate(docIdInput: CtInputTextComponent, numCliente: CtInputNumberComponent, form: any) {
	let contRequest = {      
			"Entity": "ASOCIADO_PATRONO_PM",
			"OperationName": "CRE_ASOCIADO_PATRONO_PM",
			"Type": 1,
			"Data": [
				{
				"ID": "AABC3yAAZAAAcNOAAP",
				"ArrayEntities": {
					"List": [
					{
						"Name": "OCUPACION",
						"Alias": "OCUPACION",
						"Value": this.utilService.getStringAttribute('OCUPACION', form.ArrayEntities.List)
					},
			
					{
						"Name": "CORREO",
						"Alias": "CORREO",
						"Value": this.utilService.getStringAttribute('CORREO', form.ArrayEntities.List)
					},
			
					{
						"Name": "TELEFONO",
						"Alias": "TELEFONO",
						"Value": this.utilService.getStringAttribute('TELEFONO', form.ArrayEntities.List)
					}      
					
					]
				},
				"Entity": 620,
				"EntityInt": 620,
				"Auditable": false,
				"PCID": null
				}
			],
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions": null
		}

		this.executeUpdateAsociadoPatronoRequest(contRequest);
	}

	private executeUpdateAsociadoPatronoRequest(contRequest: { Entity: string; OperationName: string; Type: number; Data: { ID: string; ArrayEntities: { List: { Name: string; Alias: string; Value: any; }[]; }; Entity: number; EntityInt: number; Auditable: boolean; PCID: any; }[]; UserCode: string; Source: string; Conditions: any; }) {
		this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/UpdateWithOperationAndEntity', contRequest).subscribe({
			next: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.successMessage, "success")]);
			},
			error: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.errorMessage, "error")]);
			}
		});
	}

	public setADNDelete(docIdInput: CtInputTextComponent, numCliente: CtInputNumberComponent) {
		let contRequest = {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [{
			  "Name": "NUM_PATRONO",
			  "Alias": "NUM_PATRONO",
			  "Value": numCliente,
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			},
			{
				"Name": "DOC_IDENTIFICACION",
				"Alias": "DOC_IDENTIFICACION",
				"Value": docIdInput,
				"Display": "",
				"Type": 1,
				"FamilyId": ""
			  }
			]
		  },
		  "Data": [],
		  "Files": []
		}
	
		this.executeDeleteAsociadoPatronoRequest(contRequest);
	}

	private executeDeleteAsociadoPatronoRequest(contRequest: { Type: number; UserCode: string; Source: string; Conditions: { Data: ({ Name: string; Alias: string; Value: CtInputNumberComponent; Display: string; Type: number; FamilyId: string; } | { Name: string; Alias: string; Value: CtInputTextComponent; Display: string; Type: number; FamilyId: string; })[]; }; Data: any[]; Files: any[]; }) {
		this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/DeleteWithOperation', contRequest).subscribe({
			next: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.successMessage, "success")]);
			},
			error: () => {
				this.componentService.utl_show_message(null, [this.setMessage(this.errorMessage, "error")]);
			}
		});
	}

	public setMessage(pmessage, ptype) {
		return {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [
			{
			  "Name": "TITLE",
			  "Alias": "TITLE",
			  "Value": "",
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			},
			{
			  "Name": "MESSAGE",
			  "Alias": "MESSAGE",
			  "Value": pmessage,
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			},
			{
			  "Name": "TYPE",
			  "Alias": "TYPE",
			  "Value": ptype,
			  "Display": "",
			  "Type": 1,
			  "FamilyId": ""
			}
			]
		  },
		  "Data": []
		}
	}
	
	private  navigateToPA_VI05() {
		this.storeService.deleteState('docIdentificacionAso');
		this.router.navigate(['home/view/PA_VI05']);
	}

// Custom Select
  private setCustomSelects(action: Action): void {
    let selectDesde: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[0]);
    let selectHasta: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[1]);
	let numPatrono = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
	let docIdentificacion = this.utilService.getComponentRef(action.conditionParams[3]).getValue();
    this.getListPeriodos(numPatrono,docIdentificacion).subscribe({
      next: (response: ApiResponseModel) => {
        let adnList = response['Data'];
     let optionsDesde = this.utilService.convertAdnToSelectOptions(adnList , selectDesde.getFieldValue(), selectDesde.getFieldText());
     let optionsHasta = this.utilService.convertAdnToSelectOptions(adnList , selectHasta.getFieldValue(), selectHasta.getFieldText());
     if (optionsDesde.length == 0){
      optionsDesde = [{text: 'No hay periodos para filtrar', value: null }]
	  optionsHasta = [{text: 'No hay periodos para filtrar', value: null }]
     }
     selectDesde.options = optionsDesde;
     selectHasta.options = optionsHasta;
      }
  });
  }

  private getListPeriodos(numPatrono, docIdentificacion): Observable<any> {
    const requestData: any = this.getListaMetadata(numPatrono, docIdentificacion);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/ASOCIADO_PATRONO_PM/SER_RET_PER_CUOTAS_REC', requestData);
  }

  private getListaMetadata(numPatrono, docIdentificacion){
  let contRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_PATRONO",
          "Alias": "NUM_PATRONO",
          "Value": numPatrono,
          "Display": "",
          "Type":1,
          "FamilyId": ""
        },{
		  "Name": "DOC_IDENTIFICACION",
          "Alias": "DOC_IDENTIFICACION",
          "Value": docIdentificacion,
          "Display": "",
          "Type":1,
          "FamilyId": ""
		}
        ]
      },
      "Data": []
    }

    return contRequest;
  }

  //Validations
  public validacionFormUpdate(action: Action): boolean {
    let form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
    let elements = form.getFormElements();
    let value = true;
    value = this.formValidation(elements);
    return value;
  }

  private formValidation(elements): boolean {
    for (let element of elements) {
        if (element instanceof InputBaseComponent) {
            if (this.isFieldEmpty(element)) {
                this.messageValidationForm('Por favor, complete todos los campos obligatorios antes de enviar el formulario. Los campos marcados con * son requeridos.');
                return false;
            } else {
                if (!this.validateField(element)) {
                    return false;
                }
            }
        }
    }
    return true;
}

private isFieldEmpty(element: InputBaseComponent): boolean {
    return element.getValue() === '' || element.getValue() === null;
}

private validateField(element: InputBaseComponent): boolean {
    switch (element.getModelId()) {
        case 'OCUPACION':
            if (element.getValue() === 'null' || element.getValue() === 'No indica' || element.getValue() === "") {
                this.messageValidationForm('El tipo de ocupación seleccionado para la institución parece incorrecto. Por favor, revise y corrija esta selección para continuar.');
                return false;
            }
            break;
        case 'CORREO':
            if (!this.validationEmail(element)) {
                this.messageValidationForm('El dato ingresado para correo electrónico institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
        case 'TELEFONO':
            if (element.getValue().length < 8) {
                this.messageValidationForm('El dato ingresado para teléfono institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
    }
    return true;
}


  private messageValidationForm(message): void {
    this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message ,true, 'Aceptar', 'Cancelar');
  }

  private validationEmail(element): boolean{
  const pattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(pattern.test(element.getValue())){
      return true;
    }else return false;
  }
	  
	/* -------------------- END CONTROLLER LOGIC ----------------- */
}